var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: {
        "background-color": "#F0F0EF",
        height: "535px",
        overflow: "auto"
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$tc("TheWorkOrder")) + "\n        "),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.receivedData.label))
                ]),
                _vm._v(
                  "\n        " + _vm._s(_vm.$tc("WithPriority")) + "\n        "
                ),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.receivedData.priority.label))
                ]),
                _vm._v(
                  "\n        " + _vm._s(_vm.$tc("ShouldStart")) + "\n        "
                ),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.receivedData.start_date))
                ]),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$tc("AndIsExpected")) +
                    " " +
                    _vm._s(_vm.$tc("ToEndBy")) +
                    "\n        "
                ),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.receivedData.end_date) + ".")
                ])
              ]),
              _vm._v(" "),
              _vm.actionType === "edit"
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "on-clickaway",
                          rawName: "v-on-clickaway",
                          value: _vm.reset,
                          expression: "reset"
                        }
                      ]
                    },
                    [
                      _c("div", { staticClass: "text-start" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex mt-3 mb-3 align-center",
                            staticStyle: { width: "100%" }
                          },
                          [
                            _c("span", { staticStyle: { width: "50px" } }, [
                              _vm._v("Activities:")
                            ]),
                            _vm._v(" "),
                            _c("ActivityTasksState", {
                              class: {
                                opacity:
                                  _vm.objectType === null && _vm.state !== null
                              },
                              attrs: {
                                activitiesOrTasks: _vm.receivedData.activities
                              },
                              on: { isActive: _vm.setState }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-start" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex mt-3 mb-3 align-center",
                            staticStyle: { width: "100%" }
                          },
                          [
                            _c("span", { staticStyle: { width: "50px" } }, [
                              _vm._v("Tasks:")
                            ]),
                            _vm._v(" "),
                            _c("ActivityTasksState", {
                              class: {
                                opacity:
                                  _vm.objectType !== null && _vm.state !== null
                              },
                              attrs: { activitiesOrTasks: _vm.taskSelection },
                              on: { isActive: _vm.setState }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-sheet",
                {
                  staticClass: "d-flex justify-start align-end pl-1 mb-1",
                  attrs: { color: "#F0F0EF", height: "30" }
                },
                [
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.$tc("WorkOrder")) + " • ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "nudge-right": 40,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "auto"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "span",
                                _vm._g(
                                  _vm._b(
                                    { staticClass: "text-size ml-2" },
                                    "span",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v(_vm._s(_vm.title))]
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.menu2,
                        callback: function($$v) {
                          _vm.menu2 = $$v
                        },
                        expression: "menu2"
                      }
                    },
                    [
                      _vm._v(" "),
                      _c("v-date-picker", {
                        on: {
                          input: function($event) {
                            _vm.menu2 = false
                          }
                        },
                        model: {
                          value: _vm.date,
                          callback: function($$v) {
                            _vm.date = $$v
                          },
                          expression: "date"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("calendar", {
                ref: "calendar",
                attrs: {
                  receivedEvents: _vm.showDetails,
                  choosenDate: _vm.date,
                  startDate: _vm.receivedData.start_date,
                  endDate: _vm.receivedData.end_date,
                  height: "300",
                  disabledView: _vm.disabledView,
                  disabled: true
                }
              }),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "table",
                {
                  staticClass: "mt-2",
                  staticStyle: { width: "100%" },
                  attrs: { cellspacing: "0" }
                },
                [
                  _c("thead", [
                    _c(
                      "tr",
                      { staticClass: "text-left" },
                      _vm._l(_vm.headers, function(header) {
                        return _c(
                          "th",
                          {
                            key: header.name,
                            staticStyle: { "text-align": "left" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(header.name) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.receivedData.activities, function(
                        activities,
                        activitiesIndex
                      ) {
                        return _c(
                          "tr",
                          {
                            key: activitiesIndex,
                            staticClass: "align-top",
                            class: {
                              opacity: _vm.state !== activities.state,
                              "task-opacity":
                                (_vm.state !== activities.state &&
                                  activities.tasks.find(function(item) {
                                    return item.state === _vm.state
                                  })) ||
                                _vm.state === null
                            }
                          },
                          [
                            !_vm.selectedTemplates.includes(activities.title)
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "text-truncate",
                                    staticStyle: { "max-width": "100px" }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "font",
                                        attrs: { title: activities.title }
                                      },
                                      [_vm._v(_vm._s(activities.title))]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "table-border text-truncate",
                                staticStyle: { "max-width": "150px" }
                              },
                              [
                                activities.label
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "font",
                                        attrs: { title: activities.label }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(activities.label)
                                        )
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass: "font text-truncate",
                                        attrs: {
                                          title:
                                            _vm.getObjectTypeLabel(
                                              activities.object_type
                                            ) +
                                            " " +
                                            activities.id
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.getObjectTypeLabel(
                                                activities.object_type
                                              )
                                            ) +
                                            "\n                " +
                                            _vm._s(activities.id)
                                        )
                                      ]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "ul",
                                { staticClass: "table-border" },
                                _vm._l(activities.tasks, function(tasks, i) {
                                  return _c(
                                    "li",
                                    {
                                      key: i,
                                      staticClass: "align-center",
                                      class: {
                                        opacity: tasks.state !== _vm.state,
                                        "task-opacity":
                                          _vm.state === activities.state ||
                                          _vm.state === null
                                      },
                                      staticStyle: { "max-width": "100px" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-truncate",
                                          class: {
                                            "d-flex": tasks.state,
                                            "mt-1": tasks.state
                                          }
                                        },
                                        [
                                          _c("task-state-icon", {
                                            attrs: { state: tasks.state }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "font",
                                              attrs: { title: tasks.title }
                                            },
                                            [_vm._v(_vm._s(tasks.title))]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "ul",
                                { staticClass: "table-border" },
                                _vm._l(activities.tasks, function(tasks, i) {
                                  return _c(
                                    "li",
                                    {
                                      key: i,
                                      class: {
                                        opacity: tasks.state !== _vm.state,
                                        "task-opacity":
                                          _vm.state === activities.state ||
                                          _vm.state === null
                                      },
                                      staticStyle: { width: "100%" }
                                    },
                                    [
                                      tasks.user_assignee_id
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "d-flex align-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        bottom: "",
                                                        color: "white",
                                                        "content-class":
                                                          "toolTip"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-avatar",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        attrs: {
                                                                          height:
                                                                            "17",
                                                                          width:
                                                                            "17"
                                                                        }
                                                                      },
                                                                      "v-avatar",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c("img", {
                                                                      attrs: {
                                                                        src: _vm.getImageUrl(
                                                                          tasks.user_assignee_id
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "toolTip"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getUserName(
                                                                tasks.user_assignee_id
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "d-flex align-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        bottom: "",
                                                        color: "white",
                                                        "content-class":
                                                          "toolTip"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _c(
                                                                  "v-avatar",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        attrs: {
                                                                          height:
                                                                            "17",
                                                                          width:
                                                                            "17",
                                                                          left:
                                                                            ""
                                                                        }
                                                                      },
                                                                      "v-avatar",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c("img", {
                                                                      attrs: {
                                                                        src: _vm.getCompanyImage(
                                                                          tasks.company_id
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      tasks.company_id
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "toolTip"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getCompanyName(
                                                                    tasks.company_id
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "toolTip"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "No Company or User selected"
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "ul",
                                { staticClass: "table-border" },
                                _vm._l(activities.tasks, function(tasks, i) {
                                  return _c(
                                    "li",
                                    {
                                      key: i,
                                      class: {
                                        opacity: tasks.state !== _vm.state,
                                        "task-opacity":
                                          _vm.state === activities.state ||
                                          _vm.state === null
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            tasks.scheduled_date
                                              ? _vm.getDateTime(
                                                  tasks.scheduled_date
                                                )
                                              : "No Date"
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "ul",
                                { staticClass: "table-border" },
                                _vm._l(activities.tasks, function(tasks, i) {
                                  return _c(
                                    "li",
                                    {
                                      key: i,
                                      staticStyle: { color: "#B8B8BC" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(tasks.execution_time) +
                                          " Min\n                "
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("tr"),
                      _vm._v(" "),
                      _c("tr")
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37696972", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37696972","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/WorkOrderSummary.vue
// module id = null
// module chunks = 